import { RequestMethod } from './APICall';
export class Campaign {
    constructor(data = {}, api) {
        this.data = {};
        this.images = [];
        this.data = data;
        this.id = data.id;
        this.api = api;
    }
    save(data) {
        return new Promise((resolve, reject) => {
            const request = {
                requestMethod: this.id ? RequestMethod.PUT : RequestMethod.POST,
                endpoint: this.id ? `campaign/${this.id}` : 'campaign',
                data,
            };
            this.api.send(request)
                .then((res) => {
                this.data = res;
                resolve(res);
            }).catch(reject);
        });
    }
}
//# sourceMappingURL=Campaign.js.map